<template>
  <section class="bg">

    <Header page="surveys"/>

    <!-- Empty Wallet Alert -->
    <a-alert
    v-if="false"
    message="Your wallet balance is empty, visit settings to top up."
    :afterClose="goToBilling"
    show-icon type="warning" close-text="View Wallet" class="empty-wallet"/>

    <!-- SURVEY CARDS -->
    <div v-if="surveys !== null" class="card-container">

      <!-- CREATE SURVEY CARD -->
      <div
      @click="goToNewSurveyPage"
      id="new-survey-card">
        <h2>New Survey</h2>
        <p>Time to ask people what they think</p>
        <center>
          <div></div>
        </center>
      </div>

      <!-- SURVEY CARD -->
      <template v-for="(survey, survey_index) in surveys">
        <Survey v-if="survey" :key="survey.id" :survey="survey" />
      </template>

    </div>

    <!-- LOADING -->
    <div v-if="!surveys" class="loading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 40px; color: #1BD285;" spin />
      </a-spin>
    </div>

  </section>
</template>


<script>

import Header from '@/components/Header.vue';
import Survey from '@/components/SurveyCard.vue';
import { db_helper } from '../store/db_helper.js';

export default {
  name: 'Surveys',
  components: {
    Header,
    Survey
  },
  data: function () {
    return {}
  },
  computed: {

    surveys () {
      return this.$store.state.surveys;
    }

  },
  methods: {

    goToNewSurveyPage() {
      analytics.track('New Survey Card Clicked');
      this.$router.push('/new-survey');
    },

    goToBilling() {
      console.log('Go to billing');
    }

  },

  mounted() {

    // Resets New Survey Inputter
    this.$store.commit('resetSurvey');

  },

  created() {
    analytics.page('Surveys');
  }

};
</script>

<style lang="scss" scoped>

section.bg{
  padding-bottom: 50px;
  background-image: linear-gradient(135deg, #eff0f3 1%,#fefeff 100%);
  min-height: 100%;
}

.card-container{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 1000px;
  margin: 0 auto;
  margin-top: 20px;
  font-family: "Montserrat", sans-serif;
}

.loading{
  height: 40px;
  width: 40px;
  margin: 0 auto;
  margin-top: 105px;
  display: block;
}

.empty-wallet{
  width: 930px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: -25px;
}

#new-survey-card{
  width: 450px;
  height: 389px;
  padding: 40px;
  padding-top: 100px;
  margin-top: 25px;
  margin-right: 15px;
  margin-left: 15px;
  background-color: white;
  background-image: url("../assets/new-survey-card.svg");
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: 250px 110px;
  border: 2px dashed #D6D8E0;
  border-radius: 8px;
  box-shadow: 0 0 8px 0 rgba(0,0,0,.08);
  align-self: flex-start;
  font-family: "Montserrat", sans-serif;
  cursor: pointer;
  p, h2, h3, h3, h4, span{
    color: #0D303F;
  }
  h2{
    color: #19C48E;
    text-align: center;
    font-size: 26px;
    font-weight: 700;
  }
  p{
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    opacity: .6;
  }
  div{
    margin-top: 25px;
    height: 50px;
    width: 50px;
    background-image: url("../assets/new-survey-card-plus.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    transition: all 0.3s ease;
  }
  transition: all 0.3s ease-in;
  &:hover{
    border-color: #19C48E;
    div{
      transform: scale(1.1);
    }
  }
}


@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {

.card-container{
  width: 100%;
  padding: 20px;
  margin-top: 0px;
}

#new-survey-card{
  width: 100%;
  height: 280px;
  padding-top: 60px;
  margin-left: 0px;
  margin-right: 0px;
  background-size: 170px 80px;
  h2{
    font-size: 25px;
  }
  p{
    font-size: 14px;
  }
  div{
    margin-top: 15px;
    height: 40px;
    width: 40px;
  }
}
}


/* Ipad Portrait */
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {
  .card-container{
    width: 100%;
    padding: 20px;
    margin-top: 0px;
  }
  #new-survey-card{
    width: 45%;
  }
}

</style>
